import React, { useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Column, Control, Label } from "rbx";
import FilterButtons from "../../../components/FilterButtons";

import { DateInput } from "../../../components/inputs";

const INITIAL_FILTER_STATE = {};

const VehicleELDFilter = ({ filters, onFilter, onClose }) => {
  const [inputs, setInputs] = useState({ ...filters });

  const handleDateChange = e => {
    const updates = { ...inputs };
    const { value } = e.target;
    updates[e.target.name] = value;
    setInputs({ ...updates });
  };

  const handleClose = () => onClose(onFilter(inputs));
  const handleCancel = () => onClose();
  const handleReset = () => onClose(onFilter({ ...INITIAL_FILTER_STATE }));

  return (
    <div className="inspection-modal-container">
      <Column.Group>
        <Column>
          <Control>
            <Label>Start Date</Label>
            <DateInput
              name="ELDDate_gte"
              value={
                inputs.ELDDate_gte
                  ? moment(inputs.ELDDate_gte).format("YYYY-MM-DD")
                  : ""
              }
              onChange={handleDateChange}
            />
          </Control>
        </Column>
        <Column>
          <Control>
            <Label>End Date</Label>
            <DateInput
              name="ELDDate_lte"
              value={
                inputs.ELDDate_lte
                  ? moment(inputs.ELDDate_lte).format("YYYY-MM-DD")
                  : ""
              }
              onChange={handleDateChange}
            />
          </Control>
        </Column>
      </Column.Group>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </div>
  );
};

VehicleELDFilter.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func
};
export default VehicleELDFilter;
